"use strict";
exports.__esModule = true;
exports.findPresetByPermissions = exports.getPermissionsByPreset = exports.PermissionsByPreset = exports.Preset = void 0;
var wix_data_schema_types_1 = require("@wix/wix-data-schema-types");
var lodash_1 = require("lodash");
var Preset;
(function (Preset) {
    Preset["CONTENT_FOR_YOUR_SITE"] = "CONTENT_FOR_YOUR_SITE";
    Preset["FORM_INPUTS"] = "FORM_INPUTS";
    Preset["USER_GENERATED_CONTENT"] = "USER_GENERATED_CONTENT";
    Preset["CONTENT_FOR_SITE_MEMBERS"] = "CONTENT_FOR_SITE_MEMBERS";
    Preset["FORM_INPUTS_FOR_SITE_MEMBERS"] = "FORM_INPUTS_FOR_SITE_MEMBERS";
    Preset["PRIVATE_DATA"] = "PRIVATE_DATA";
    Preset["CUSTOM"] = "CUSTOM";
})(Preset = exports.Preset || (exports.Preset = {}));
exports.PermissionsByPreset = {
    CONTENT_FOR_YOUR_SITE: {
        insert: wix_data_schema_types_1.PermissionRole.admin,
        read: wix_data_schema_types_1.PermissionRole.anyone,
        update: wix_data_schema_types_1.PermissionRole.admin,
        remove: wix_data_schema_types_1.PermissionRole.admin
    },
    FORM_INPUTS: {
        insert: wix_data_schema_types_1.PermissionRole.anyone,
        read: wix_data_schema_types_1.PermissionRole.admin,
        update: wix_data_schema_types_1.PermissionRole.admin,
        remove: wix_data_schema_types_1.PermissionRole.admin
    },
    USER_GENERATED_CONTENT: {
        insert: wix_data_schema_types_1.PermissionRole.siteMember,
        read: wix_data_schema_types_1.PermissionRole.anyone,
        update: wix_data_schema_types_1.PermissionRole.siteMemberAuthor,
        remove: wix_data_schema_types_1.PermissionRole.siteMemberAuthor
    },
    CONTENT_FOR_SITE_MEMBERS: {
        insert: wix_data_schema_types_1.PermissionRole.admin,
        read: wix_data_schema_types_1.PermissionRole.siteMember,
        update: wix_data_schema_types_1.PermissionRole.admin,
        remove: wix_data_schema_types_1.PermissionRole.admin
    },
    FORM_INPUTS_FOR_SITE_MEMBERS: {
        insert: wix_data_schema_types_1.PermissionRole.siteMember,
        read: wix_data_schema_types_1.PermissionRole.admin,
        update: wix_data_schema_types_1.PermissionRole.admin,
        remove: wix_data_schema_types_1.PermissionRole.admin
    },
    PRIVATE_DATA: {
        insert: wix_data_schema_types_1.PermissionRole.admin,
        read: wix_data_schema_types_1.PermissionRole.admin,
        update: wix_data_schema_types_1.PermissionRole.admin,
        remove: wix_data_schema_types_1.PermissionRole.admin
    },
    CUSTOM: {}
};
exports.getPermissionsByPreset = function (preset) {
    if (!exports.PermissionsByPreset[preset]) {
        throw Error("Unkown preset preset " + preset);
    }
    return exports.PermissionsByPreset[preset];
};
exports.findPresetByPermissions = function (permissions) {
    var preset = Object.keys(exports.PermissionsByPreset).find(function (preset) {
        return lodash_1.isEqual(exports.PermissionsByPreset[preset], permissions);
    });
    return preset || Preset.CUSTOM;
};
//# sourceMappingURL=permissionsPresets.js.map